'use client';

import { LogOut } from "lucide-react";
import { useAuth } from "../../hooks/useAuth"; // ajustează calea dacă e necesar
import { useNavigate } from "react-router-dom";

export default function LogoutButton() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch(`${import.meta.env.VITE_BACKEND_URL}/api/auth/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });

      logout();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error("Eroare la logout:", error);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
    >
      <LogOut className="w-5 h-5 text-gray-600" />
    </button>
  );
}
